import React from 'react';
import { Toaster as HotToaster, toast as hotToast } from 'react-hot-toast';
import { CircleCheckBig, Ban, AlertTriangle, Info } from 'lucide-react';

/**
 * Toast Component
 * 
 * @example
 * import { toast } from '../../components';
 * 
 * toast('Event has been created.');
 * toast.success('Success message');
 * toast.error('Error message');
 * toast.warning('Warning message');
 * toast.info('Info message');
 */

const SuccessIcon = () => (
    <CircleCheckBig className="w-4.5 h-4.5 text-emerald-600" />
);

const ErrorIcon = () => (
    <Ban className="w-4.5 h-4.5 text-red-600" />
);

const WarningIcon = () => (
    <AlertTriangle className="w-4.5 h-4.5 text-amber-600" />
);

const InfoIcon = () => (
    <Info className="w-4.5 h-4.5 text-blue-600" />
);

function Toaster({ className, ...props }) {
  const baseStyle = {
    background: '#ffffff',
    color: 'oklch(12.9% 0.042 264.695)',
    border: '1px solid oklch(92.9% 0.013 255.508)',
    borderRadius: '0.375rem',
    boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    fontFamily: 'var(--font-sans)',
    fontWeight: '500',
    padding: '12px 16px',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
  };

  return (
    <HotToaster
      position="top-center"
      toastOptions={{
        duration: 4000,
        style: baseStyle,
        success: {
          icon: <SuccessIcon />,
          style: baseStyle,
        },
        error: {
          icon: <ErrorIcon />,
          style: baseStyle,
        },
      }}
      {...props}
    />
  );
}

Toaster.defaultProps = {
  className: '',
};

// Create a toast API that matches the sonner API
const toast = (message, options) => {
  return hotToast(message, options);
};

toast.success = (message, options) => {
  return hotToast.success(message, {
    icon: <SuccessIcon />,
    ...options,
  });
};

toast.error = (message, options) => {
  return hotToast.error(message, {
    icon: <ErrorIcon />,
    ...options,
  });
};

toast.warning = (message, options) => {
  return hotToast(message, {
    icon: <WarningIcon />,
    ...options,
  });
};

toast.info = (message, options) => {
  return hotToast(message, {
    icon: <InfoIcon />,
    ...options,
  });
};

export { Toaster, toast };
export default Toaster;

